const aux_mapa = {}

aux_mapa.get_geoJson_by_key = (key) => {
    console.log("GET_MAPA", key)
    const keyInt = parseInt(key)
    switch (keyInt) {
        case -1:
            return require('../geo/brasil-ibge.json')
        case 12: //Acre
            return require('../geo/geojs-12-mun.json')
        case 27: //Alagoas
            return require('../geo/geojs-27-mun.json')
        case 16: //Amapá
            return require('../geo/geojs-16-mun.json')
        case 13: //Amazonas
            return require('../geo/geojs-13-mun.json')
        case 29: //Bahia
            return require('../geo/geojs-29-mun.json')
        case 23: //Ceará
            return require('../geo/geojs-23-mun.json')
        case 53: //Distrito Federal
            return require('../geo/geojs-53-mun.json')
        case 32: //Espírito Santo
            return require('../geo/geojs-32-mun.json')
        case 52: //Goiás
            return require('../geo/geojs-52-mun.json')
        case 21: //Maranhão
            return require('../geo/geojs-21-mun.json')
        case 51: //Mato Grosso
            return require('../geo/geojs-51-mun.json')
        case 50: //Mato Grosso do Sul
            return require('../geo/geojs-50-mun.json')
        case 31: //Minas Gerais
            return require('../geo/geojs-31-mun.json')
        case 15: //Pará
            return require('../geo/geojs-15-mun.json')
        case 25: //Paraíba
            return require('../geo/geojs-25-mun.json')
        case 41: //Paraná
            return require('../geo/geojs-41-mun.json')
        case 26: //Pernambuco
            return require('../geo/geojs-26-mun.json')
        case 22: //Piauí
            return require('../geo/geojs-22-mun.json')
        case 24: //Rio Grande do Norte
            return require('../geo/geojs-24-mun.json')
        case 43: //Rio Grande do Sul
            return require('../geo/geojs-43-mun.json')
        case 33: //Rio de Janeiro
            return require('../geo/geojs-33-mun.json')
        case 11: //Rondônia
            return require('../geo/geojs-11-mun.json')
        case 14: //Roraima
            return require('../geo/geojs-14-mun.json')
        case 42: //Santa Catarina
            return require('../geo/geojs-42-mun.json')
        case 35: //São Paulo
            return require('../geo/geojs-35-mun.json')
        case 28: //Sergipe
            return require('../geo/geojs-28-mun.json')
        case 17: //Tocantins
            return require('../geo/geojs-17-mun.json')
        default: return null
    }
}

aux_mapa.get_zoom_by_key = (key) => {
    const keyInt = parseInt(key)
    switch (keyInt) {
        case -1:
            return 4
        case 12: //Acre
            return 6
        case 27: //Alagoas
            return 8
        case 16: //Amapá
            return 7
        case 13: //Amazonas
            return 5
        case 29: //Bahia
            return 6
        case 23: //Ceará
            return 7
        case 53: //Distrito Federal
            return 8
        case 32: //Espírito Santo
            return 8
        case 52: //Goiás
            return 6
        case 21: //Maranhão
            return 6
        case 51: //Mato Grosso
            return 6
        case 50: //Mato Grosso do Sul
            return 6
        case 31: //Minas Gerais
            return 6
        case 15: //Pará
            return 5
        case 25: //Paraíba
            return 8
        case 41: //Paraná
            return 7
        case 26: //Pernambuco
            return 7
        case 22: //Piauí
            return 7
        case 24: //Rio Grande do Norte
            return 8
        case 43: //Rio Grande do Sul
            return 6
        case 33: //Rio de Janeiro
            return 7
        case 11: //Rondônia
            return 7
        case 14: //Roraima
            return 6
        case 42: //Santa Catarina
            return 7
        case 35: //São Paulo
            return 7
        case 28: //Sergipe
            return 8
        case 17: //Tocantins
            return 6
        default: return null
    }
}

aux_mapa.get_position_tooltip_by_key = (key) => {
    const keyInt = parseInt(key)
    switch (keyInt) {
        case -1:
            return {'bottomRight': [-27.460548931020252, -30.78081383980933],
                    'bottomLeft': [-31.060548931020252, -67.78081383980933],
                    'topRight': [1.460548931020252, -20.78081383980933] }
        case 12: //Acre
            return {'bottomRight': [-11.71978753865, -66.0064499341],
            'bottomLeft': [-9.71978753865, -76.0064499341],
            'topRight': [-0.71978753865, -65.0064499341] }
        case 27: //Alagoas
            return {'bottomRight': [-10.148733304, -35.2078279054],
            'bottomLeft': [-9.948733304, -38.0078279054],
            'topRight': [-7.148733304, -35.4078279054] }
        case 16: //Amapá
            return {'bottomRight': [0.1161250405, -49.06909393715],
            'bottomLeft': [0.0161250405, -54.56909393715],
            'topRight': [6.0161250405, -48.96909393715] }
        case 13: //Amazonas
            return {'bottomRight': [-9.2976740317, -54.38969553335],
            'bottomLeft': [-9.4976740317, -77.38969553335],
            'topRight': [15.4976740317, -55.38969553335] }
        case 29: //Bahia
            return {'bottomRight': [-15.807981665361021, -34.5181948050895],
            'bottomLeft': [-16.460548931020252, -44.78081383980933],
            'topRight': [-7.807981665361021, -32.5181948050895] }
        case 23: //Ceará
            return {'bottomRight': [-7.209916804349999,-34.9348004192],
            'bottomLeft': [-8.209916804349999,-39.7348004192],
            'topRight': [-2.809916804349999,-35.4348004192] }
        case 53: //Distrito Federal
            return {'bottomRight': [-16.47551346635, -46.597208489599996],
            'bottomLeft': [-15.97551346635, -49.197208489599996],
            'topRight': [-13.47551346635, -46.297208489599996] }
        case 32: //Espírito Santo
            return {'bottomRight': [-19.275372496950003, -38.094480736205],
            'bottomLeft': [-20.775372496950003, -39.74480736205],
            'topRight': [-17.575372496950003, -38.64480736205] }
        case 52: //Goiás
            return {'bottomRight': [-22.44941369995,-41.44736034565],
            'bottomLeft': [-20.44941369995,-51.44736034565],
            'topRight': [-13.44941369995,-40.44736034565] }
        case 21: //Maranhão
            return {'bottomRight': [-11.509431368800001,-35.22555941305],
            'bottomLeft': [-10.509431368800001,-45.22555941305],
            'topRight': [-1.509431368800001,-37.22555941305] }
        case 51: //Mato Grosso
            return {'bottomRight': [-18.017310937649999,-47.4186381655],
            'bottomLeft': [-19.017310937649999,-58.4186381655],
            'topRight': [-10.017310937649999,-47.0186381655] }
        case 50: //Mato Grosso do Sul
            return {'bottomRight': [-26.738480194250002,-45.23396080715],
            'bottomLeft': [-25.238480194250002,-55.23396080715],
            'topRight': [-17.738480194250002,-45.23396080715] }
        case 31: //Minas Gerais
            return {'bottomRight': [-21.572781009028915, -37.24534848498033],
            'bottomLeft': [-23.460548931020252, -45.78081383980933],
            'topRight': [-14.460548931020252, -35.78081383980933] }
        case 15: //Pará
            return {'bottomRight': [-15.2677852673000001,-37.241071095449996],
            'bottomLeft': [-12.2677852673000001,-57.241071095449996],
            'topRight': [0.2677852673000001,-35.241071095449996] }
        case 25: //Paraíba
            return {'bottomRight': [-8.946202044750001, -36.655204103499995],
            'bottomLeft': [-8.346202044750001, -38.305204103499995],
            'topRight': [-7.946202044750001, -35.005204103499995] }
        case 41: //Paraná
            return {'bottomRight': [-26.49466031675,-47.286896617],
            'bottomLeft': [-26.89466031675,-52.286896617],
            'topRight': [-21.19466031675,-47.286896617] }
        case 26: //Pernambuco
            return {'bottomRight': [-9.159720572006426, -34.140292213780485],
            'bottomLeft': [-9.559720572006426, -39.540292213780485],
            'topRight': [-3.959720572006426, -33.640292213780485]}
        case 22: //Piauí
            return {'bottomRight': [-7.18664773475, -38.201737725],
            'bottomLeft': [-9.48664773475, -41.801737725],
            'topRight': [-3.18664773475, -38.801737725] }
        case 24: //Rio Grande do Norte
            return {'bottomRight': [-6.555375346897024, -35.19533279237359],
            'bottomLeft': [-6.795375346897024, -37.59533279237359],
            'topRight': [-3.395375346897024, -34.89533279237359] }
        case 43: //Rio Grande do Sul
            return {'bottomRight': [-34.31910121735719, -46.90992674243819],
            'bottomLeft': [-36.31910121735719, -54.90992674243819],
            'topRight': [-27.31910121735719, -44.90992674243819] }
        case 33: //Rio de Janeiro
            return {'bottomRight': [-24.118495955465472, -39.624423303298],
            'bottomLeft': [-25.318495955465472, -43.624423303298],
            'topRight': [-20.318495955465472, -38.624423303298] }
        case 11: //Rondônia
            return {'bottomRight': [-13.94654599520754, -60.591521018642824],
            'bottomLeft': [-12.94654599520754, -64.591521018642824],
            'topRight': [-7.54654599520754, -59.591521018642824] }
        case 14: //Roraima
            return {'bottomRight': [-2.0990160323076408, -54.19996764125659],
            'bottomLeft': [-3.5990160323076408, -62.19996764125659],
            'topRight': [6.0990160323076408, -52.19996764125659] }
        case 42: //Santa Catarina
            return {'bottomRight': [-22.72851839544836, -48.3256715063666],
            'bottomLeft': [-28.12851839544836, -53.6256715063666],
            'topRight': [-22.62851839544836, -52.6256715063666] }
        case 35: //São Paulo
            return {'bottomRight': [-24.176908909954673, -45.26404533379526],
            'bottomLeft': [-23.676908909954673, -51.26404533379526],
            'topRight': [-19.476908909954673, -44.86404533379526] }
        case 28: //Sergipe
            return {'bottomRight': [-11.715927333228598, -35.75706131960973],
            'bottomLeft': [-12.015927333228598, -37.85706131960973],
            'topRight': [-9.615927333228598, -35.05706131960973] }
        case 17: //Tocantins
            return {'bottomRight': [-13.264492722547383, -41.3446701237403],
            'bottomLeft': [-15.264492722547383, -48.3446701237403],
            'topRight': [-6.264492722547383, -39.3446701237403] }
        default: return null
    }
}

aux_mapa.get_center_by_key = (key) => {
    const keyInt = parseInt(key)
    switch (keyInt) {
        case -1:
            return [-23.376566863651192, -46.69949329460831]
        case 12: //Acre
            return [-8.857946150115659, -70.43149438852303]
        case 27: //Alagoas
            return [-9.610306691892612, -36.56065441211053]
        case 16: //Amapá
            return [1.5012432663430584, -51.82647410470675]
        case 13: //Amazonas
            return [-4.269367112495817, -64.69551841264345]
        case 29: //Bahia
            return [-14.807981665361021, -38.5181948050895]
        case 23: //Ceará
            return [-7.057348097511227, -37.46698672649174]
        case 53: //Distrito Federal
            return [-15.779056338562649, -47.79357644895591]
        case 32: //Espírito Santo
            return [-19.97275535458153, -39.54161953423043]
        case 52: //Goiás
            return [-20.774582239581008, -45.31455764800618]
        case 21: //Maranhão
            return [-9.91165655595327, -40.12344364768116]
        case 51: //Mato Grosso
            return [-16.916775876063642, -52.481265342203876]
        case 50: //Mato Grosso do Sul
            return [-25.076853662308043, -49.64510408633668]
        case 31: //Minas Gerais
            return [-21.572781009028915, -41.54534848498033]
        case 15: //Pará
            return [-13.841359554421463, -45.25468917116337]
        case 25: //Paraíba
            return [-8.247867839886322, -36.65505574139097]
        case 41: //Paraná
            return [-25.5746298056127, -49.89813385500782]
        case 26: //Pernambuco
            return [-8.959720572006426, -36.540292213780485]
        case 22: //Piauí
            return [-7.735200276055961, -41.34821943501687]
        case 24: //Rio Grande do Norte
            return [-5.955375346897024, -36.19533279237359]
        case 43: //Rio Grande do Sul
            return [-34.31910121735719, -49.90992674243819]
        case 33: //Rio de Janeiro
            return [-24.318495955465472, -40.624423303298]
        case 11: //Rondônia
            return [-12.54654599520754, -61.991521018642824]
        case 14: //Roraima
            return [-3.0990160323076408, -57.19996764125659]
        case 42: //Santa Catarina
            return [-27.12851839544836, -50.6256715063666]
        case 35: //São Paulo
            return [-22.976908909954673, -48.06404533379526]
        case 28: //Sergipe
            return [-11.615927333228598, -36.35706131960973]
        case 17: //Tocantins
            return [-13.264492722547383, -43.3446701237403]
        default: return null
    }
}

export default aux_mapa